import axios from 'axios'
import {
    ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentCreateRequest,
    ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-most-likely-morphologic-code-assignment/configuration-personnel-most-likely-morphologic-code-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentCreateRequest): Promise<ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelMostLikelyMorphologicCodeAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelMostLikelyMorphologicCodeAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelMostLikelyMorphologicCodeAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelMostLikelyMorphologicCodeAssignments/${personnelMostLikelyMorphologicCodeAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelMostLikelyMorphologicCodeAssignmentService = new ConfigurationPersonnelMostLikelyMorphologicCodeAssignmentService()
